import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "../Carrer.css";
import { database } from "../firebase";

const defaultStudents = [
  { name: "DEVI PRASAD PATEL", desc: "Ajeet Enterprises, Damoh", url: `${process.env.PUBLIC_URL}/1.jpg` },
  { name: "RUBAL JAIN", desc: "Shree Enterprises, Damoh", url: `${process.env.PUBLIC_URL}/2.jpg` },
  { name: "CHIRAG RAJAK", desc: "Abhay Computer, Honey sales, Damoh", url: `${process.env.PUBLIC_URL}/3.jpg` },
  { name: "MAYANK JAIN", desc: "Damoh Battery Service, Damoh", url: `${process.env.PUBLIC_URL}/4.jpg` },
  { name: "GURNEESH SINGH BAGGA", desc: "Vidhya Sagar Logistics, Damoh", url: `${process.env.PUBLIC_URL}/5.jpg` },
  { name: "JITENDRA PATEL", desc: "Smart homes, Damoh", url: `${process.env.PUBLIC_URL}/6.jpg` },
  { name: "SUBODH RAJAK", desc: "BALAJI MARKETING, Damoh", url: `${process.env.PUBLIC_URL}/7.jpg` },
  { name: "AMAN ASATI", desc: "Texol company, Damoh", url: `${process.env.PUBLIC_URL}/8.jpg` },
  { name: "VIKASH AHIRWAL", desc: "Nirman, Damoh", url: `${process.env.PUBLIC_URL}/9.jpg` },
  { name: "SURYANSH SINGHAI", desc: "Upkar Traders, Damoh", url: `${process.env.PUBLIC_URL}/10.jpg` },
];

const OfflineCourses = () => {
  const [images, setImages] = useState([]);
  const [learners, setLearners] = useState([]);

  useEffect(() => {
    const imagesRef = ref(database, "carouselImages");
    onValue(imagesRef, (snapshot) => {
      const data = snapshot.val();
      setImages(data ? Object.values(data) : []);
    });

    const learnersRef = ref(database, "happyLearners");
    onValue(learnersRef, (snapshot) => {
      const data = snapshot.val();
      const firebaseLearners = data ? Object.values(data) : [];
      setLearners([...defaultStudents, ...firebaseLearners]);
    });
  }, []);

  const allCourses = {
    offline: [
      { img: 'advancement 1.png',   title: 'Master Accountant using Tally',          badge: 'Premium',        badgeColor: '#e67e22', desc: 'A premium course bridging academic learning and industry needs.', duration: '4 Months' },
      { img: 'webinar 1.png',       title: 'Tally with Online Internship',           badge: 'With Internship', badgeColor: '#27ae60', desc: 'Hands-on accounting experience with NEP-aligned Online Internship.', duration: '3 Months' },
      { img: 'tax 1.png',           title: 'Tally with GST Simulation',              badge: 'Popular',         badgeColor: '#e67e22', desc: 'Practise GST Returns with Tally Certification to Level Up Your Career.', duration: '2 Months' },
      { img: 'technique 1.png',     title: 'Office Automation',                      badge: 'Beginner',        badgeColor: '#90b732', desc: 'Basic Computing, MS Word, Excel & PowerPoint.', duration: '1.5 Months' },
      { img: 'our-existence.png',   title: 'Payroll & Income Tax',                   badge: 'Specialized',     badgeColor: '#8e44ad', desc: 'Manage payroll & taxes with TallyPrime — process salaries & ensure compliance.', duration: '2 Months' },
      { img: 'technique 1.png',     title: 'Complete Guide to Inventory Management', badge: 'Specialized',     badgeColor: '#8e44ad', desc: 'Master inventory control with TallyPrime — track, manage & optimize seamlessly.', duration: '2 Months' },
      { img: 'tally Prime new.png', title: 'TallyEssential',                         badge: 'Beginner',        badgeColor: '#90b732', desc: 'A Complete Guide on Business Accounting.', duration: '2 Months' },
      { img: 'tally Prime new.png', title: 'TallyProfessional',                      badge: 'Advanced',        badgeColor: '#4d3d6c', desc: 'A Complete Guide on Advanced Business Accounting and Indian Taxation.', duration: '3 Months' },
      { img: 'tax 1.png',           title: 'GST using TallyPrime',                   badge: 'Popular',         badgeColor: '#e67e22', desc: 'A Complete Guide on Goods and Services Tax (GST).', duration: '1.5 Months' },
      { img: 'our-existence.png',   title: 'TDS using Tally',                        badge: 'Specialized',     badgeColor: '#8e44ad', desc: 'A Complete Guide on Tax Deducted at Source (TDS).', duration: '1 Month' },
      { img: 'advancement 1.png',   title: 'GCC VAT using TallyPrime',               badge: 'International',   badgeColor: '#2980b9', desc: 'A Complete Guide on GCC VAT Concepts and its Usage.', duration: '1 Month' },
      { img: 'tally Prime new.png', title: 'TallyEssential International',           badge: 'International',   badgeColor: '#2980b9', desc: 'A Complete Guide on Business Accounting in Middle East Countries.', duration: '2 Months' },
      { img: 'technique 1.png',     title: 'TDL Essential International',            badge: 'Advanced',        badgeColor: '#4d3d6c', desc: 'Develop and Deploy Solutions using TDL for TallyPrime.', duration: '2 Months' },
    ],
    online: [
      { img: 'technique 1.png',     title: 'Simplifying Inventory Management',       badge: 'Self-paced',  badgeColor: '#90b732', desc: 'Optimise stock, cut costs, and streamline inventory with efficient tracking.' },
      { img: 'tax 1.png',           title: 'GST Filing with TallyPrime',             badge: 'Popular',     badgeColor: '#e67e22', desc: 'Gain expertise in GST compliance, manage returns seamlessly.' },
      { img: 'our-existence.png',   title: 'Accounts Receivables & Payables',        badge: 'Self-paced',  badgeColor: '#90b732', desc: 'Streamline invoicing, track payments, and manage receivables & payables.' },
      { img: 'technique 1.png',     title: 'TDL Essential',                          badge: 'Advanced',    badgeColor: '#4d3d6c', desc: 'Develop and Deploy Solutions using TDL for TallyPrime.' },
      { img: 'webinar 1.png',       title: 'Mastering Payroll Management',           badge: 'Specialized', badgeColor: '#8e44ad', desc: 'Acquire practical skills in Payroll and HR Management using Tally.' },
      { img: 'advancement 1.png',   title: 'Data Analysis and Verification Tools',   badge: 'Self-paced',  badgeColor: '#90b732', desc: 'Excel in financial analysis, execute high-value transactions, and data validation.' },
      { img: 'tally Prime new.png', title: 'TallyPrime Basics',                      badge: 'Beginner',    badgeColor: '#27ae60', desc: 'Excel in precise transaction recording, accounts management, and bank reconciliation.' },
      { img: 'tax 1.png',           title: 'TallyPrime with GST',                    badge: 'Popular',     badgeColor: '#e67e22', desc: 'Excel in intricate tax landscapes, ensure GST compliance precision.' },
      { img: 'technique 1.png',     title: 'Microsoft Excel - Beginner to Advanced', badge: 'Self-paced',  badgeColor: '#90b732', desc: 'Master Microsoft Excel from basic functions to advanced data analysis.' },
      { img: 'our-existence.png',   title: 'Computer Basics with Microsoft Office',  badge: 'Beginner',    badgeColor: '#27ae60', desc: 'Master essential computer skills and effectively use Microsoft Office.' },
      { img: 'advancement 1.png',   title: 'Principles of Tally Bookkeeping',        badge: 'Beginner',    badgeColor: '#27ae60', desc: 'Excel in accounting transactions, precise bookkeeping, and Tally proficiency.' },
      { img: 'our-existence.png',   title: 'Financial Markets and Services',          badge: 'Self-paced',  badgeColor: '#2980b9', desc: 'Excel in comprehensive understanding of financial markets.' },
    ],
    free: [
      { img: 'tax 1.png',           title: 'Smart Cash Management',  badge: 'Free', badgeColor: '#27ae60', desc: 'Master cash management, understand accounting basics, manage receivables/payables.' },
      { img: 'our-existence.png',   title: 'Short Guide to GST',     badge: 'Free', badgeColor: '#27ae60', desc: 'Master GST registration, tax structuring, HSN/SAC codes, invoicing, and seamless filing.' },
    ],
  };

  const [activeTab, setActiveTab] = useState('offline');
  const current = allCourses[activeTab];

  const tabs = [
    { key: 'offline', label: '🏫 Offline', count: allCourses.offline.length },
    { key: 'online',  label: '💻 Online',  count: allCourses.online.length },
    { key: 'free',    label: '🎁 Free',    count: allCourses.free.length },
  ];

  return (
    <div className="container-fluid my-1">

      {/* ── Courses Section ── */}
      <div className="py-5" style={{ background: '#fff' }}>
        <div className="text-center mb-4">
          <h3 className="fw-bold mb-1" style={{ color: '#4d3d6c' }}>Our Courses</h3>
          <p className="text-muted" style={{ fontSize: '14px' }}>Industry-recognized certifications to launch your career.</p>
        </div>

        {/* Tabs + Enroll */}
        <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap px-3">
          {tabs.map(t => (
            <button key={t.key} onClick={() => setActiveTab(t.key)} style={{
              background: activeTab === t.key ? '#4d3d6c' : '#f8fdf0',
              color: activeTab === t.key ? '#fff' : '#555',
              border: `1.5px solid ${activeTab === t.key ? '#4d3d6c' : '#e0efc0'}`,
              borderRadius: 8, padding: '8px 20px',
              fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.2s',
            }}>
              {t.label}
              <span style={{
                background: activeTab === t.key ? '#90b732' : '#ecf3d7',
                color: activeTab === t.key ? '#fff' : '#4d7a10',
                borderRadius: 50, padding: '1px 8px', fontSize: 11, fontWeight: 700, marginLeft: 6,
              }}>{t.count}</span>
            </button>
          ))}
          <Link to="/courses" style={{
            background: '#90b732', color: '#fff', border: '1.5px solid #90b732',
            borderRadius: 8, padding: '8px 20px', fontWeight: 700, fontSize: 13, textDecoration: 'none',
          }}>Enroll Now →</Link>
        </div>

        {/* Carousel */}
        <div className="crs-carousel-wrapper">
          <div className="crs-carousel-track" key={activeTab}>
            {[...current, ...current].map((c, i) => (
              <div key={i} className={`crs-carousel-card ${
                activeTab === 'online' ? 'crs-carousel-online' :
                activeTab === 'free'   ? 'crs-carousel-free'   : ''
              }`}>
                <div className="crs-carousel-img-wrap">
                  <img
                    src={`https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/${c.img}`}
                    alt={c.title}
                  />
                </div>
                <div className="crs-carousel-body">
                  <span className="crs-carousel-badge" style={{ background: c.badgeColor }}>{c.badge}</span>
                  <h6 className="crs-carousel-title">{c.title}</h6>
                  <p className="crs-carousel-desc">{c.desc}</p>
                  <div className="crs-carousel-meta">
                    {c.duration
                      ? <><i className="bi bi-clock me-1"></i>{c.duration} &nbsp;·&nbsp; <i className="bi bi-building me-1"></i>Classroom</>
                      : <><i className="bi bi-laptop me-1"></i>Self-paced Online</>
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* View All */}
        <div className="text-center mt-4">
          <Link to="/courses" style={{
            background: '#4d3d6c', color: '#fff', borderRadius: 8,
            padding: '10px 32px', fontWeight: 700, fontSize: 14,
            textDecoration: 'none', display: 'inline-block',
          }}>View All {allCourses.offline.length + allCourses.online.length + allCourses.free.length}+ Courses →</Link>
        </div>
      </div>

      {/* ── Our Students Carousel ── */}
      <div className="carousel-section py-5" style={{ background: "#f9f9f9" }}>
        <h3 className="text-center fw-bold mb-1" style={{ color: "#2d2d2d" }}>Happy Learners</h3>
        <p className="text-center text-muted mb-4" style={{ fontSize: "14px" }}>Join thousands of certified accountants.</p>
        <div className="carousel-track-wrapper">
          <div className="carousel-track">
            {[...images, ...images].map((img, i) => (
              <div key={i} className="carousel-card">
                <div className="carousel-img-wrap">
                  <img src={img.url} alt={img.name} />
                </div>
                <div className="carousel-card-body">
                  <h6 className="carousel-name">{img.name}</h6>
                  <span className="carousel-place">📍 {img.place}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Start Learning Today Carousel ── */}
      <div className="carousel-section py-5" style={{ background: "#ecf3d7" }}>
        <h3 className="text-center fw-bold mb-1" style={{ color: "#2d2d2d" }}>Our Success Story</h3>
        <p className="text-center text-muted mb-4" style={{ fontSize: "14px" }}>Real people. Real success stories.</p>
        <div className="carousel-track-wrapper">
          <div className="carousel-track carousel-track-reverse">
            {[...learners, ...learners].map((stu, i) => (
              <div key={i} className="carousel-card">
                <div className="carousel-img-wrap">
                  <img src={stu.url} alt={stu.name} />
                </div>
                <div className="carousel-card-body">
                  <h6 className="carousel-name">{stu.name}</h6>
                  <span className="carousel-place">💼 {stu.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .carousel-section { overflow: hidden; }

        /* ── Course carousel ── */
        .crs-carousel-wrapper {
          overflow: hidden;
          position: relative;
          padding: 8px 0 16px;
        }
        .crs-carousel-wrapper::before,
        .crs-carousel-wrapper::after {
          content: '';
          position: absolute; top: 0; bottom: 0; width: 80px; z-index: 2; pointer-events: none;
        }
        .crs-carousel-wrapper::before { left: 0;  background: linear-gradient(to right, rgba(255,255,255,1), transparent); }
        .crs-carousel-wrapper::after  { right: 0; background: linear-gradient(to left,  rgba(255,255,255,1), transparent); }
        .crs-carousel-track {
          display: flex;
          gap: 20px;
          width: max-content;
          animation: scrollLeft 28s linear infinite;
        }
        .crs-carousel-track:hover { animation-play-state: paused; }
        .crs-carousel-card {
          flex: 0 0 auto;
          width: 220px;
          background: #fff;
          border-radius: 16px;
          border: 1.5px solid #e8f5c8;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: default;
        }
        .crs-carousel-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        }
        .crs-carousel-online { border-color: #d0e8ff; }
        .crs-carousel-online:hover { border-color: #2980b9; }
        .crs-carousel-free { border-color: #d5f5e3; }
        .crs-carousel-free:hover { border-color: #27ae60; }
        .crs-carousel-img-wrap {
          width: 100%;
          height: 200px;
          overflow: hidden;
          background: #ecf3d7;
          display: flex; align-items: center; justify-content: center;
        }
        .crs-carousel-online .crs-carousel-img-wrap { background: #e8f4fd; }
        .crs-carousel-free   .crs-carousel-img-wrap { background: #eafaf1; }
        .crs-carousel-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 24px;
          transition: transform 0.4s ease;
        }
        .crs-carousel-card:hover .crs-carousel-img-wrap img { transform: scale(1.08); }
        .crs-carousel-body {
          padding: 12px 14px 14px;
          text-align: center;
        }
        .crs-carousel-badge {
          color: #fff; font-size: 10px; font-weight: 700;
          border-radius: 50px; padding: 2px 10px;
          display: inline-block; margin-bottom: 6px;
        }
        .crs-carousel-title {
          font-size: 13.5px; font-weight: 700; color: #2d2d2d;
          margin-bottom: 4px; line-height: 1.4;
        }
        .crs-carousel-desc {
          font-size: 11.5px; color: #888; line-height: 1.55;
          margin-bottom: 6px;
          display: -webkit-box; -webkit-line-clamp: 2;
          -webkit-box-orient: vertical; overflow: hidden;
        }
        .crs-carousel-meta {
          font-size: 11px; color: #aaa;
        }
        .crs-carousel-meta i { color: #90b732; }
        .crs-carousel-online .crs-carousel-meta i { color: #2980b9; }
        .crs-carousel-free   .crs-carousel-meta i { color: #27ae60; }

        .carousel-track-wrapper {
          overflow: hidden;
          position: relative;
        }
        .carousel-track-wrapper::before,
        .carousel-track-wrapper::after {
          content: "";
          position: absolute;
          top: 0; bottom: 0;
          width: 80px;
          z-index: 2;
          pointer-events: none;
        }
        .carousel-track-wrapper::before { left: 0; background: linear-gradient(to right, rgba(249,249,249,0.9), transparent); }
        .carousel-track-wrapper::after  { right: 0; background: linear-gradient(to left, rgba(249,249,249,0.9), transparent); }

        .carousel-track {
          display: flex;
          gap: 20px;
          width: max-content;
          animation: scrollLeft 12s linear infinite;
        }
        .carousel-track-reverse {
          animation: scrollRight 25s linear infinite;
        }
        .carousel-track:hover,
        .carousel-track-reverse:hover { animation-play-state: paused; }

        .carousel-card {
          flex: 0 0 auto;
          width: 220px;
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .carousel-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        }
        .carousel-img-wrap {
          width: 100%;
          height: 200px;
          overflow: hidden;
          background: #f0f0f0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .carousel-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          transition: transform 0.4s ease;
        }
        .carousel-card:hover .carousel-img-wrap img { transform: scale(1.05); }

        .carousel-card-body {
          padding: 12px 14px 14px;
          text-align: center;
        }
        .carousel-name {
          font-size: 14px;
          font-weight: 700;
          color: #2d2d2d;
          margin-bottom: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .carousel-place {
          font-size: 12px;
          color: #888;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        @keyframes scrollLeft {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scrollRight {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default OfflineCourses;
